import { Dispatch } from "react";
import { createAsyncThunk } from "@reduxjs/toolkit";

import { UserEmergencyContactService } from "Bands/services";
import { USER_ACTIONS, IUserEmergencyContactPatchData } from "Bands/types";
import { API_ENDPOINTS } from "shared/constants";
import { IDataKeys } from "shared/types";
import { IStoreState } from "App/types";

export const dispatchGetUserEmergencyContacts = (dispatch: Dispatch<any>, userId?: string) => {
  dispatch(
    getUserEmergencyContacts({
      userId,
      page: 1,
      paginationKey: USER_ACTIONS.getUserEmergencyContacts,
    })
  );
};

const getUserEmergencyContacts = createAsyncThunk(
  USER_ACTIONS.getUserEmergencyContacts,
  async (
    { userId }: { userId?: string; page: number; paginationKey: string },
    { getState, rejectWithValue }
  ) => {
    try {
      const { currentUser } = (getState() as IStoreState).auth;

      const data = await UserEmergencyContactService.getUserEmergencyContacts({
        user: API_ENDPOINTS.USER(userId || currentUser?.id || ""),
      });

      return {
        [IDataKeys.userEmergencyContact]: data.userEmergencyContact,
        meta: data.meta,
        pagination: data.pagination,
      };
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const createUserEmergencyContact = createAsyncThunk(
  USER_ACTIONS.createUserEmergencyContact,
  async (contact: IUserEmergencyContactPatchData, { rejectWithValue }) => {
    try {
      const data = await UserEmergencyContactService.createUserEmergencyContact(contact);
      const id = Object.values(data?.userEmergencyContact)?.[0]?.attributes?.id;

      return { id, data };
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const editUserEmergencyContact = createAsyncThunk(
  USER_ACTIONS.editUserEmergencyContact,
  async (
    {
      id,
      data,
    }: {
      id: string;
      data: IUserEmergencyContactPatchData;
    },
    { rejectWithValue }
  ) => {
    try {
      return await UserEmergencyContactService.editUserEmergencyContact(id, data);
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const deleteUserEmergencyContact = createAsyncThunk(
  USER_ACTIONS.deleteUserEmergencyContact,
  async (id: string, { rejectWithValue }) => {
    try {
      await UserEmergencyContactService.deleteUserEmergencyContact(id);
      return {
        path: API_ENDPOINTS.USER_EMERGENCY_CONTACT(id),
        dataKey: IDataKeys.userEmergencyContact,
      };
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);
